import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const updatePassword = createAsyncThunk(
  'passwordSecurity/updatePassword',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.post(
        `${ROOT_URL}/master-user/update-password`,
        {
          oldPassword: payload.oldPassword,
          newPassword: payload.newPassword,
          confirmPassword: payload.confirmPassword,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const data = response.data;
      if (data && data.success === false) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      const errData = error.response?.data;
      if (errData) {
        return rejectWithValue(errData);
      }
      return rejectWithValue({ message: 'Something went wrong. Please try again.' });
    }
  },
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  response: null,
};

const updatePasswordSlice = createSlice({
  name: 'passwordSecurity',
  initialState,
  reducers: {
    resetUpdatePasswordState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
        state.error = null;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdatePasswordState } = updatePasswordSlice.actions;
export default updatePasswordSlice.reducer;
